export default "__VITE_PUBLIC_ASSET__0c1a377f__"